import React from 'react';
import { Modal, Box, Typography } from '@mui/material';
import successIcon from '../../assets/images/join-form/success.png'; // ✅ Yeni ikon (sen kendi ikonunu seçebilirsin)

interface SuccessModalProps {
  open: boolean;
  handleClose: () => void;
  message: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ open, handleClose, message }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
    p: 4,
    textAlign: 'center',
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <div style={{ textAlign: 'center' }}>
          <img src={successIcon} alt="Başarılı" style={{ maxWidth: '100%', margin: '0 auto' }} />
        </div>
        <Typography variant="h5" sx={{ mt: 2 }} color="success.main">
          Başarılı!
        </Typography>
        <Typography sx={{ mt: 2 }}>
          {message}
        </Typography>
      </Box>
    </Modal>
  );
};

export default SuccessModal;
